import React, {useEffect, useState} from 'react';
import { Button, Modal, Space, message } from 'antd';
import PartnerForm from '../components/PartnerForm';
import PartnerList from '../components/PartnerList';
import { useToast } from "../ToastProvider";
import { fetchPartners, createPartner, updatePartner, deletePartner } from '../services/api';

export default function PartnerPage() {
    const { addToast } = useToast();
    const [partners, setPartners] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingPartner, setEditingPartner] = useState(null);
    useEffect(() => {
        fetchPartners()
            .then(res => setPartners(res.data))
            .catch(err => addToast('Lỗi tải danh sách đối tác','error'));
    }, []);
    const openModal = (partner = null) => {
        setEditingPartner(partner);
        setModalOpen(true);
    };

    const handleSubmitPartner = async (partner) => {
        try {
            if (editingPartner) {
                await updatePartner(partner);
                addToast('Đã cập nhật đối tác','success');
            } else {
                await createPartner(partner);
                addToast('Đã Thêm mới đối tác','success');
            }
            const res = await fetchPartners();
            setPartners(res.data);
            setModalOpen(false);
        } catch (err) {
            addToast('Lỗi xử lý đối tác','error');
        }
    };

    const handleDelete = async (partner) => {
        try {
            await deletePartner(partner.id);
            setPartners(prev => prev.filter(p => p.id !== partner.id));
            addToast('Đã xóa đối tác','success');
        } catch (err) {
            addToast('Xóa thất bại','error');
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Space style={{ marginBottom: 16 }}>
                <Button type="primary" onClick={() => openModal()}>Thêm mới</Button>
            </Space>

            <PartnerList partners={partners} onEdit={openModal} onDelete={handleDelete} />

            <Modal
                title={editingPartner ? 'Cập nhật đối tác' : 'Thêm đối tác'}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                destroyOnHidden
            >
                <PartnerForm handleSubmitPartner={handleSubmitPartner} editingPartner={editingPartner} />
            </Modal>
        </div>
    );
}
